export default __webpack_public_path__ + "static/media/iridium.52613197.jpg";